import { SxProps, Theme } from "@mui/material/styles";

export const fixedModalPaperSx: SxProps<Theme> = {
  height: { xs: "90vh", md: "80vh" },
  maxHeight: { xs: "90vh", md: "80vh" },
  display: "flex",
  flexDirection: "column",
};

export const modalTitleSx: SxProps<Theme> = {
  px: { xs: 1, sm: 3 },
  pt: { xs: 1.25, sm: 2 },
};

export const modalHeaderActionsSx: SxProps<Theme> = {
  width: { xs: "100%", sm: "auto" },
  justifyContent: { xs: "flex-start", sm: "flex-end" },
  flexWrap: "wrap",
};

export const modalTabsContainerSx: SxProps<Theme> = (theme) => ({
  width: "100%",
  px: 0,
  border: 1,
  borderColor: "divider",
  borderRadius: 2,
  overflow: "hidden",
  bgcolor: theme.palette.mode === "dark" ? "grey.900" : "grey.50",
});

export const modalTabsSx: SxProps<Theme> = (theme) => ({
  minHeight: 56,
  "& .MuiTab-root": {
    minHeight: 56,
    minWidth: { xs: 96, sm: 120 },
    textTransform: "none",
    fontWeight: 500,
    fontSize: "0.9rem",
    px: { xs: 2, sm: 3 },
    gap: 1,
    borderRight: `1px solid ${theme.palette.divider}`,
    "&:last-of-type": {
      borderRight: "none",
    },
  },
  "& .MuiTabs-scrollButtons": {
    mx: 0.5,
    "&:first-of-type": {
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    "&:last-of-type": {
      borderLeft: `1px solid ${theme.palette.divider}`,
    },
    "&.Mui-disabled": {
      opacity: 0.3,
    },
  },
});

export const fixedModalDialogContentSx: SxProps<Theme> = {
  p: 0,
  flex: 1,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

export const scrollableModalDialogContentSx: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
};

export const pinnedDialogActionsSx: SxProps<Theme> = {
  flexShrink: 0,
};
